/**
 * VideoPlayer
 * @description Web component used to create videos
 */

(async () => {


  if (!customElements.get('video-player')) {

    class VideoPlayer extends HTMLElement {
      constructor() {
        super();

        let self = this;
        this.options = {};

        // Check if we have extra options on the HTML
        if (this.dataset.options) {
          const options = JSON.parse(this.dataset.options);
          if (options) {
            this.options = {
              ...options
            };
          }
        }

        this.videoElements = this.querySelectorAll('video');

        this.videoElements.forEach(currentVideo => {

          currentVideo.addEventListener('click', function(){
            currentVideo.controls = true;
            self.classList.add('video_active');
            setTimeout(function(){
              currentVideo.play();
            }, 250);
          }, false);

          if (typeof self.options.pauseOnPlay != "undefined") {
            currentVideo.addEventListener('play', function(){
              self.pauseOtherVideos(currentVideo);
            }, false);
          }
        });
      }

      /**
      * Stop other videos with the same data-video-id
      * @param {Object} event
      */
      pauseOtherVideos(currentVideo) {
        let otherVideos = document.querySelectorAll('[' + this.options.pauseOnPlay + '] video');
        otherVideos.forEach(video => {
          if (video != currentVideo) {
            video.pause();
          }
        });
      }
    }

    window.VideoPlayer = VideoPlayer;

    customElements.define('video-player', VideoPlayer);

  }

})();
